export default "__VITE_ASSET__CKEfhOTu__"